var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUserOutlineUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75,23a3.834,3.834,0,0,1,0-7.667h10a3.834,3.834,0,0,1,0,7.667ZM2.5,19.166a1.266,1.266,0,0,0,1.25,1.278h10a1.278,1.278,0,0,0,0-2.555h-10A1.265,1.265,0,0,0,2.5,19.166Zm20.008,2.7-.008-.149V19.546a3.257,3.257,0,0,0-2.769-2.965,1.278,1.278,0,0,1-.952-1.523,1.25,1.25,0,0,1,1.488-.974,5.8,5.8,0,0,1,4.725,5.2l.007.26v2.177a1.249,1.249,0,0,1-2.492.149ZM2.5,6.389A6.329,6.329,0,0,1,8.75,0,6.328,6.328,0,0,1,15,6.389,6.327,6.327,0,0,1,8.75,12.777,6.328,6.328,0,0,1,2.5,6.389Zm2.5,0A3.8,3.8,0,0,0,8.75,10.222,3.8,3.8,0,0,0,12.5,6.389,3.8,3.8,0,0,0,8.75,2.555,3.8,3.8,0,0,0,5,6.389Zm11.283,4.121a1.279,1.279,0,0,1,.936-1.533A3.432,3.432,0,0,0,20,5.75a3.431,3.431,0,0,0-2.782-3.227A1.28,1.28,0,0,1,16.282.989a1.25,1.25,0,0,1,1.5-.956A5.963,5.963,0,0,1,22.5,5.75a5.963,5.963,0,0,1-4.717,5.717,1.23,1.23,0,0,1-.283.033A1.258,1.258,0,0,1,16.282,10.511Z",
    transform: "translate(0 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserOutlineUsers);
export default __webpack_public_path__ + "static/media/Icon-User-Outline-Users.5f8875203ffca2a20d3c4f28f179cf18.svg";
export { ForwardRef as ReactComponent };